export default __webpack_public_path__ + "static/media/trending-up-green.61fa9f53.svg";